/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;
      this.checkVisible = this.checkVisible.bind(this); // Bind context for event listener
      this.onClick = this.onClick.bind(this); // Bind context for event listener
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.checkVisible);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.checkVisible);
    }

    checkVisible() {
      const body = document.body;
      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > this.pageHeight) {
          this.classList.add('back-to-top--active');
          body.classList.add('Button__active');
        } else {
          this.classList.remove('back-to-top--active');
          body.classList.remove('Button__active');
        }
      });
    }

    onClick() {
      // Smooth scrolling polyfill
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0); // Fallback for browsers without smooth scrolling
      }
    }
  }

  customElements.define('back-to-top', BackToTop);
}
